import facebookIcon from "@/mocks/assets/socialMediaIcons/facebookIcon.svg";
import instagramIcon from "@/mocks/assets/socialMediaIcons/instagramIcon.svg";
import Image from "next/image";
import LocalizedPhoneDisplay from "../_localized/localizedPhoneDisplay";
import React from "react";

export const BusinessLocations = ({
  merchantName,
  merchantAddress,
  merchantPhoneNumber,
  merchantLocale,
  merchantEmail,
  merchantColor,
  facebookUrl,
  instagramUrl,
}: any) => {
  return (
    <div
      className={[
        "flex",
        "flex-col",
        "w-[240px]",
        "max-md:ml-0",
        "max-md:w-full",
        "max-md:px-5",
        "mr-2",
        "gap-5",
        "flex justify-start items-start pb-4",
      ].join(" ")}
    >
      <span className={["text-[20px] leading-[25px] font-medium"].join(" ")}>
        {merchantName}
      </span>
      <div
        className={[
          "flex",
          "flex-col",
          "gap-2",
          "flex justify-start items-start",
        ].join(" ")}
      >
        <p className={["text-[15px] leading-[21.75px] font-normal"].join(" ")}>
          {merchantAddress.address1 + " "}
        </p>
        {merchantAddress.address2 && (
          <p
            className={["text-[15px] leading-[21.75px] font-normal"].join(" ")}
          >
            {merchantAddress.address2 + ", "}
          </p>
        )}
        <p className={["text-[15px] leading-[21.75px] font-normal"].join(" ")}>
          {`${merchantAddress.city}, ${merchantAddress.state}, ${merchantAddress.zip}`}
        </p>
        <p className={["text-[15px] leading-[21.75px] font-normal"].join(" ")}>
          <LocalizedPhoneDisplay
            phoneNumber={merchantPhoneNumber}
            locale={merchantLocale}
            international={true}
          />
        </p>
        <a
          href={`mailto:${merchantEmail}`}
          className={`max-w-[240px] break-words underline text-[15px] leading-[21.75px] font-normal`}
          style={{ color: merchantColor }}
        >
          {merchantEmail}
        </a>
      </div>
      <div
        className={[
          "flex",
          "flex-row",
          "flex justify-between self-start gap-[30px]",
        ].join(" ")}
      >
        {facebookUrl && (
          <a href={facebookUrl} target="_blank" rel="noreferrer">
            <Image src={facebookIcon} alt="Facebook Icon" />
          </a>
        )}
        {instagramUrl && (
          <a href={instagramUrl} target="_blank" rel="noreferrer">
            <Image src={instagramIcon} alt="Instagram Icon" />
          </a>
        )}
      </div>
    </div>
  );
};
